import { Button, Form, Input, InputNumber, Radio, Spin } from 'antd';
import { get, isEmpty, mapValues } from 'lodash';
import React, { useState } from 'react';

import processResponseError from '@System/api/processResponseError';
import { t } from '@System/i18n';
import notification from '@System/notification';

import ModalService from '../components/ModalService';
import api from '../services/api';

const AppliancesSvg = () => (
    <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M8.375 5.07031C8.375 5.52604 8.29297 5.96354 8.12891 6.38281C7.96484 6.80208 7.73698 7.16667 7.44531 7.47656C7.17188 7.78646 6.84375 8.04167 6.46094 8.24219L6.73438 13.1914C6.77083 13.6107 6.63411 13.9753 6.32422 14.2852C6.03255 14.5951 5.67708 14.75 5.25781 14.75H3.61719C3.19792 14.75 2.83333 14.5951 2.52344 14.2852C2.23177 13.9753 2.10417 13.6107 2.14062 13.1914L2.41406 8.24219C1.83073 7.93229 1.36589 7.50391 1.01953 6.95703C0.673177 6.39193 0.5 5.76302 0.5 5.07031C0.5 4.48698 0.645833 3.46615 0.9375 2.00781C0.992188 1.64323 1.17448 1.34245 1.48438 1.10547C1.79427 0.86849 2.16797 0.75 2.60547 0.75C2.95182 0.75 3.26172 0.822917 3.53516 0.96875C3.79036 0.822917 4.09115 0.75 4.4375 0.75C4.78385 0.75 5.08464 0.822917 5.33984 0.96875C5.61328 0.822917 5.92318 0.75 6.26953 0.75C6.70703 0.75 7.08073 0.86849 7.39062 1.10547C7.70052 1.34245 7.88281 1.64323 7.9375 2.00781C8.22917 3.46615 8.375 4.48698 8.375 5.07031ZM5.09375 7.33984C5.49479 7.26693 5.84115 7.13021 6.13281 6.92969C6.42448 6.71094 6.65234 6.44661 6.81641 6.13672C6.98047 5.80859 7.0625 5.45312 7.0625 5.07031C7.0625 4.96094 7.05339 4.82422 7.03516 4.66016C7.01693 4.49609 6.9987 4.33203 6.98047 4.16797C6.96224 4.00391 6.9349 3.83073 6.89844 3.64844C6.86198 3.44792 6.82552 3.27474 6.78906 3.12891C6.77083 2.96484 6.7526 2.81901 6.73438 2.69141C6.71615 2.54557 6.69792 2.4362 6.67969 2.36328L6.65234 2.25391C6.63411 2.1263 6.4974 2.0625 6.24219 2.0625C6.00521 2.0625 5.8776 2.1263 5.85938 2.25391V5.37109C5.84115 5.51693 5.70443 5.58984 5.44922 5.58984C5.19401 5.58984 5.05729 5.51693 5.03906 5.37109L4.84766 2.25391C4.8112 2.1263 4.66536 2.0625 4.41016 2.0625C4.17318 2.0625 4.04557 2.1263 4.02734 2.25391L3.83594 5.37109C3.81771 5.51693 3.68099 5.58984 3.42578 5.58984C3.17057 5.58984 3.03385 5.51693 3.01562 5.37109V2.25391C2.9974 2.1263 2.86068 2.0625 2.60547 2.0625C2.36849 2.0625 2.24089 2.1263 2.22266 2.25391C1.94922 3.62109 1.8125 4.5599 1.8125 5.07031C1.8125 5.65365 1.98568 6.15495 2.33203 6.57422C2.69661 6.97526 3.17969 7.23047 3.78125 7.33984L3.45312 13.2734C3.4349 13.3828 3.48958 13.4375 3.61719 13.4375H5.25781C5.38542 13.4375 5.4401 13.3828 5.42188 13.2734L5.09375 7.33984ZM11.1641 9.25391C9.88802 8.23307 9.25 7.05729 9.25 5.72656C9.25 4.43229 9.7513 3.28385 10.7539 2.28125C11.7747 1.26042 12.8047 0.75 13.8438 0.75C14.263 0.75 14.6185 0.895833 14.9102 1.1875C15.2201 1.47917 15.375 1.82552 15.375 2.22656V13.2734C15.375 13.6745 15.2201 14.0208 14.9102 14.3125C14.6185 14.6042 14.263 14.75 13.8438 14.75H12.3125C11.8568 14.75 11.474 14.5859 11.1641 14.2578C10.8724 13.9479 10.7448 13.5742 10.7812 13.1367L11.1641 9.25391ZM10.5625 5.72656C10.5625 6.76562 11.2188 7.73177 12.5312 8.625L12.0938 13.2734C12.0755 13.3828 12.1484 13.4375 12.3125 13.4375H13.8438C13.9896 13.4375 14.0625 13.3828 14.0625 13.2734V2.22656C14.0625 2.11719 13.9896 2.0625 13.8438 2.0625C13.1693 2.0625 12.4492 2.44531 11.6836 3.21094C10.9362 3.95833 10.5625 4.79688 10.5625 5.72656Z"
            fill="black"
        />
    </svg>
);

const FashionSvg = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="15" viewBox="0 0 19 15" fill="none">
        <path
            d="M17.9727 4.05859C18.0638 4.33203 18.0456 4.60547 17.918 4.87891L16.4688 7.77734C16.3411 8.05078 16.1315 8.23307 15.8398 8.32422C15.5664 8.41536 15.3021 8.38802 15.0469 8.24219L14.418 7.94141C14.3451 7.92318 14.2721 7.93229 14.1992 7.96875C14.1263 8.00521 14.0898 8.06901 14.0898 8.16016V13.2188C14.0898 13.638 13.9349 13.9935 13.625 14.2852C13.3333 14.5951 12.9779 14.75 12.5586 14.75H5.99609C5.72266 14.75 5.46745 14.6771 5.23047 14.5312C4.99349 14.4036 4.80208 14.2214 4.65625 13.9844C4.52865 13.7474 4.46484 13.4922 4.46484 13.2188V8.13281C4.46484 8.0599 4.42839 8.00521 4.35547 7.96875C4.30078 7.91406 4.23698 7.90495 4.16406 7.94141L3.50781 8.26953C3.2526 8.39714 2.97917 8.41536 2.6875 8.32422C2.41406 8.21484 2.21354 8.03255 2.08594 7.77734L0.636719 4.87891C0.509115 4.60547 0.490885 4.33203 0.582031 4.05859C0.673177 3.78516 0.855469 3.58464 1.12891 3.45703L6.54297 0.75C6.54297 0.75 6.57031 0.804688 6.625 0.914062C6.69792 1.00521 6.7526 1.07812 6.78906 1.13281C6.82552 1.16927 6.88932 1.24219 6.98047 1.35156C7.08984 1.44271 7.18099 1.51562 7.25391 1.57031C7.34505 1.625 7.46354 1.69792 7.60938 1.78906C7.75521 1.86198 7.90104 1.92578 8.04688 1.98047C8.21094 2.01693 8.39323 2.05339 8.59375 2.08984C8.8125 2.10807 9.04036 2.11719 9.27734 2.11719C9.49609 2.11719 9.69661 2.10807 9.87891 2.08984C10.0612 2.07161 10.2253 2.04427 10.3711 2.00781C10.5352 1.95312 10.6719 1.90755 10.7812 1.87109C10.9089 1.81641 11.0273 1.7526 11.1367 1.67969C11.2461 1.58854 11.3372 1.52474 11.4102 1.48828C11.4831 1.43359 11.556 1.36068 11.6289 1.26953C11.7018 1.17839 11.7565 1.11458 11.793 1.07812C11.8294 1.04167 11.875 0.986979 11.9297 0.914062C11.9844 0.822917 12.0117 0.768229 12.0117 0.75L17.4258 3.45703C17.6992 3.58464 17.8815 3.78516 17.9727 4.05859ZM15.4023 6.95703L16.6328 4.52344L12.3672 2.39062C11.6016 3.08333 10.5716 3.42969 9.27734 3.42969C7.98307 3.42969 6.95312 3.08333 6.1875 2.39062L1.92188 4.52344L3.15234 6.95703L5.14844 6.02734C5.29427 5.95443 5.43099 5.96354 5.55859 6.05469C5.70443 6.14583 5.77734 6.26432 5.77734 6.41016V13.2188C5.77734 13.3646 5.85026 13.4375 5.99609 13.4375H12.5586C12.7044 13.4375 12.7773 13.3646 12.7773 13.2188V6.41016C12.7773 6.24609 12.8411 6.1276 12.9688 6.05469C13.1146 5.96354 13.2604 5.95443 13.4062 6.02734L15.4023 6.95703Z"
            fill="black"
        />
    </svg>
);

const Quotation = () => {
    const [form] = Form.useForm();

    const [valueQuantity, setValueQuantity] = useState();
    const [sellerRef, setSellerRef] = useState('')
    const [quantityPerMonth, setQuantityPerMonth] = useState();
    const [cost, setCost] = useState()
    const [quotation, setQuotation] = useState({});

    const [visible, setVisible] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleVisibleModalService = () => {
        setVisible(true);
    };

    const handleRequestQuotation = (service = []) => {
        form.validateFields().then(values => {
            Object.keys(values).forEach(key => {
                if (key !== 'seller_ref' && key !== 'quantity' && key !== 'quantity_per_month') {
                    values[key] /= 100;
                }
            });
            const data = {
                ...values,
                seller_ref: sellerRef,
                service_ids: service,
            };
            setLoading(true);
            api.getQuotation(data)
                .then(res => {
                    notification.success(t('message.request_quotation_success'));
                    setQuotation(get(res, 'data'));
                    // (storage_fee * số lượng trên tháng * 30 ngay) / so luong tren don
                    const cost_storage = (+get(res, 'data.storage_fee') * +quantityPerMonth * 30) / +valueQuantity
                    setCost(cost_storage)

                    setVisible(false);
                })
                .catch(err => {
                    notification.error(t('message.request_quotation_failed'));
                    processResponseError(err);
                })
                .finally(() => {
                    setLoading(false);
                });
        }).catch(() => {
            setVisible(false)
        });
    };

    const formatCurrency = value => {
        return (value || 0).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,') + 'đ';
    };

    const handleChangeIndustry = value => {
        switch (value) {
            case 'fashion':
                form.setFieldsValue({
                    length: '22',
                    width: '30',
                    height: '2',
                });
                return;
            case 'appliances':
                form.setFieldsValue({
                    length: '30',
                    width: '15',
                    height: '15',
                });
                return;
            case 'other':
                form.setFieldsValue({
                    width: undefined,
                    height: undefined,
                    length: undefined,
                });
                return;
            default:
                return;
        }
    };
    return (
        <>
            <Form form={form} layout="vertical" className="quotation"

            >
                <div className="quotation-box">
                    <div className="quotation-content left">
                        <h4 className="quotation-content__question">{t('quotation.industry_business_question')}</h4>
                        <Radio.Group onChange={e => handleChangeIndustry(e.target.value)} className="quotation-content__industry">
                            <Radio.Button value="fashion" className="quotation-content__industry-item">
                                <FashionSvg />
                                {t('label.fashion')}
                            </Radio.Button>
                            <Radio.Button value="appliances" className="quotation-content__industry-item">
                                <AppliancesSvg />
                                {t('label.appliances')}
                            </Radio.Button>
                            <Radio.Button value="other" className="quotation-content__industry-item">
                                <AppliancesSvg />
                                {t('label.other')}
                            </Radio.Button>
                        </Radio.Group>
                        <h4 className="quotation-content__question">{t('quotation.size_package_question')}</h4>
                        <div className="quotation-content__size">
                            <Form.Item
                                name="length"
                                label={t('quotation.length')}
                                rules={[
                                    {
                                        required: true,
                                        message: t('validation:required', {
                                            attribute: t('product:placeholder.length'),
                                        }),
                                    },
                                ]}
                            >
                                <InputNumber placeholder="10cm" style={{ width: '100%' }} min={1} />
                            </Form.Item>
                            <Form.Item
                                name="width"
                                label={t('quotation.width')}
                                rules={[
                                    {
                                        required: true,
                                        message: t('validation:required', {
                                            attribute: t('product:placeholder.width'),
                                        }),
                                    },
                                ]}
                            >
                                <InputNumber placeholder="10cm" style={{ width: '100%' }} min={1} />
                            </Form.Item>
                            <Form.Item
                                name="height"
                                label={t('quotation.height')}
                                rules={[
                                    {
                                        required: true,
                                        message: t('validation:required', {
                                            attribute: t('product:placeholder.height'),
                                        }),
                                    },
                                ]}
                            >
                                <InputNumber placeholder="20cm" style={{ width: '100%' }} min={1} />
                            </Form.Item>
                        </div>
                        <h4 className="quotation-content__question">{t('quotation.quantity_per_order')}</h4>
                        <Form.Item
                            name="quantity"
                            rules={[
                                {
                                    required: true,
                                    message: t('validation:required', {
                                        attribute: t('label.quantity'),
                                    }),
                                },
                            ]}
                        >
                            <InputNumber
                                value={valueQuantity}
                                onChange={value => setValueQuantity(value)}
                                placeholder={t('placeholder.product_quantity')}
                                style={{ width: '100%' }}
                                min={1}
                            />
                        </Form.Item>
                        <h4 className="quotation-content__question">{t('quotation.quantity_per_month')}</h4>
                        <Form.Item
                            name="quantity_per_month"
                            rules={[
                                {
                                    required: true,
                                    message: t('validation:required', {
                                        attribute: t('label.quantity'),
                                    }),
                                },
                            ]}
                        >
                            <InputNumber
                                value={quantityPerMonth}
                                onChange={value => setQuantityPerMonth(value)}
                                placeholder={t('placeholder.product_quantity')}
                                style={{ width: '100%' }}
                                min={1}
                            />
                        </Form.Item>
                        <h4 className="quotation-content__question">{t('quotation.referral_code_please')}</h4>
                        <Form.Item >
                            <Input placeholder={t('label.ref')} onChange={(e) => setSellerRef(e.target.value)} />
                        </Form.Item>
                        <Button type="primary" onClick={() => handleRequestQuotation()}>
                            {t('btn.quotation_request')}
                        </Button>
                    </div>

                    <div className="quotation-content right">
                        <Spin spinning={loading}>
                            <h2>{t('title.quotation_service')}</h2>
                            <div className="quotation-content__price first-row quotation-content-product_per_order">
                                <p>{t('quotation.product_per_order')}</p>
                                <span>{valueQuantity}</span>
                            </div>

                            <div className="quotation-content__price quotation-content-total_fulfillment_price">
                                <div>
                                    {t('quotation.total_fulfillment_price')}
                                    <p>{t('quotation.export_import_price')}</p>
                                </div>
                                <span>{formatCurrency(quotation?.export_fee + quotation?.import_fee)}</span>
                            </div>
                            <div className="quotation-content__price quotation-content-storage_cost">
                                <p>{t('quotation.storage_cost')}</p>
                                <span>{formatCurrency(cost)}</span>
                            </div>
                            <div className="quotation-content__price quotation-content-refund_cost">
                                <p>{t('quotation.refund_cost')}</p>
                                <span>{formatCurrency(quotation?.return_good_fee)}</span>
                            </div>
                        </Spin>
                        <div className="quotation-content__func">
                            <blockquote>
                                {t('quotation.quoteblock_1')} <span>{t('quotation.quoteblock_2')} </span>
                                {t('quotation.quoteblock_3')}
                            </blockquote>

                            <Form.Item shouldUpdate className="submit">
                                {() => (

                                    <Button type="primary" className="btn btn-quotation__modal" onClick={handleVisibleModalService} disabled={
                                        !form.isFieldsTouched(true) ||
                                        form.getFieldsError().filter(({ errors }) => errors.length).length > 0
                                    }>
                                        {t('btn.quotation_advanced')}
                                    </Button>
                                )}
                            </Form.Item>
                        </div>
                    </div>
                </div>
            </Form>
            {visible && <ModalService setVisible={setVisible} handleRequestQuotation={handleRequestQuotation} />}
        </>
    );
};

export default Quotation;
